<script setup lang="ts">
import { ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

import { baseInput, baseTextarea } from "@/common/components";

import { ReportPayloadType } from "@/common/types/report";

const { t } = useI18n();

const emit = defineEmits(["update-data"]);

const props = withDefaults(
  defineProps<{
    data: ReportPayloadType | null;
    title?: string;
    width?: string;
  }>(),
  {
    width: "100%",
  }
);

const defaultData = {
  description: "",
  name: "",
};

const payload = ref<ReportPayloadType>({ ...defaultData });

function update() {
  emit("update-data", payload.value);
}

watchEffect(() => {
  if (props.data) {
    payload.value = { ...props.data };
  }
});
</script>

<template>
  <section class="form-content" :style="{ width: width }">
    <div v-if="title" class="title">
      {{ title }}
    </div>
    <form>
      <base-input
        v-model="payload.name"
        :value="payload.name"
        :placeholder="t('common.placeholders.name')"
        @input="update()"
      >
        <template #label>
          {{ t("common.labels.name") }} *
        </template>
      </base-input>

      <base-textarea
        v-model="payload.description"
        :value="payload.description"
        :placeholder="t('common.placeholders.describe')"
        @input="update()"
      >
        <template #label>
          {{ t("common.labels.description") }}
        </template>
      </base-textarea>
    </form>
  </section>
</template>

<style lang="scss" scoped>
.form-content {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;

  .title {
    display: inline-flex;
    align-items: center;
    gap: 1rem;
    font-size: 1.5rem;
    font-weight: bold;
    text-transform: uppercase;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}
</style>